import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const SCROLL_POSITION_KEY = 'examPage_scrollPosition';

export const useSavedScroll = (isDataLoaded: boolean = true) => {
  const location = useLocation();
  const scrollPositionRef = useRef<number>(0);
  const hasRestoredScrollRef = useRef<boolean>(false);
  const isExamPageRef = useRef<boolean>(false);

  
  useEffect(() => {
    const mainElement = document.querySelector('.MainContent');
    
    if (!mainElement) return;

    const handleScroll = () => {
      scrollPositionRef.current = mainElement.scrollTop;
    };

    mainElement.addEventListener('scroll', handleScroll, { passive: true });
    
    return () => {
      mainElement.removeEventListener('scroll', handleScroll);
    };
  }, []);

  
  useEffect(() => {
    const isExamPage = location.pathname === '/exam' || location.pathname === '/exam/';
    isExamPageRef.current = isExamPage;

    return () => {
      
      if (isExamPageRef.current && scrollPositionRef.current > 0) {
        sessionStorage.setItem(SCROLL_POSITION_KEY, scrollPositionRef.current.toString());
      }
    };
  }, [location.pathname]);

  
  useEffect(() => {
    if (hasRestoredScrollRef.current) return;
    
    const isExamPage = location.pathname === '/exam' || location.pathname === '/exam/';
    if (!isExamPage) return;

    const savedScrollPosition = sessionStorage.getItem(SCROLL_POSITION_KEY);
    
    if (savedScrollPosition) {
      const scrollPos = parseInt(savedScrollPosition, 10);
      
      
      const restoreScroll = () => {
        const mainElement = document.querySelector('.MainContent');
        if (mainElement && scrollPos > 0) {
          mainElement.scrollTop = scrollPos;
          hasRestoredScrollRef.current = true;
          sessionStorage.removeItem(SCROLL_POSITION_KEY);
        }
      };

      
      requestAnimationFrame(restoreScroll);
    } else {
      
      hasRestoredScrollRef.current = true;
    }
  }, [location.pathname]);
};
